<template>
    <div class="wrapper">
        <MyHeader/>

        <div class="container page-content">
            <router-view/>
        </div>

        <MyFooter/>
    </div>
</template>

<script>
import MyHeader from "@/views/PageHeader.vue";
import MyFooter from "@/views/PageFooter.vue";

export default {
    name: "PageBuild",
    components: {
        MyHeader,
        MyFooter,
    }
};
</script>

<style scoped>
.wrapper {
    display: block;
    position: relative;

}
.page-content { margin-top: 50px; margin-bottom: 100px; }
@media (max-width: 767px) {
    .page-content { margin-top: 24px; margin-bottom: 32px; }
}
</style>
